import { useQuery } from '@tanstack/react-query'

import type { MostActiveUser } from '@/schema'

import { ViewLevel } from '../constants'
import { getMostActiveUsers } from '../services'
import { useDashboardStore } from '../store'

type TUseMostActiveUsersResult = {
  data: MostActiveUser[]
  isLoading: boolean
  isError: boolean
  error: Error | null
}

export const useMostActiveUsers = (): TUseMostActiveUsersResult => {
  const { filters, viewLevel } = useDashboardStore()

  // Only fetch data when at org level
  const isEnabled = viewLevel === ViewLevel.ORG

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['mostActiveUsers', filters.companyId],
    queryFn: async ({ signal }) => {
      const response = await getMostActiveUsers(
        filters.companyId ? { company_id: filters.companyId } : undefined,
        undefined,
        signal
      )
      return response
    },
    enabled: isEnabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })

  return {
    data: data?.data?.[0]?.data || [],
    isLoading,
    isError,
    error: error || null,
  }
}
